/**
 * Criterios de orden compartidos entre los entornos de facturas RECIBIDAS y
 * EMITIDAS, para que la pantalla y las exportaciones (SUENLACE, Excel, ZIP)
 * muestren siempre la misma secuencia.
 *
 * Regla única: fecha ascendente y, a igualdad de fecha, número de factura de
 * menor a mayor con orden natural (respetando letras y ceros a la izquierda).
 */

/** Compara dos números de factura de forma natural (1 < 2 < 10 < 10A). */
export const compareInvoiceNumber = (a?: string | null, b?: string | null): number => {
  const sa = (a ?? "").toString().trim();
  const sb = (b ?? "").toString().trim();
  const aNum = parseInt(sa.replace(/\D/g, ""), 10) || 0;
  const bNum = parseInt(sb.replace(/\D/g, ""), 10) || 0;
  if (aNum !== bNum) return aNum - bNum;
  return sa.localeCompare(sb, undefined, { numeric: true, sensitivity: "base" });
};

/** Compara por fecha (ISO yyyy-mm-dd) y, si empatan, por número de factura. */
export const compareByDateThenNumber = (
  a: { date?: string | null; invoiceNumber?: string | null },
  b: { date?: string | null; invoiceNumber?: string | null },
): number => {
  const dateCompare = (a?.date ?? "").toString().localeCompare((b?.date ?? "").toString());
  if (dateCompare !== 0) return dateCompare;
  return compareInvoiceNumber(a?.invoiceNumber, b?.invoiceNumber);
};

/** Devuelve una copia ordenada con el criterio común. */
export const sortByDateThenNumber = <T extends { date?: string | null; invoiceNumber?: string | null }>(
  items: T[],
): T[] => [...items].filter(Boolean).sort(compareByDateThenNumber);

/** Devuelve una copia ordenada únicamente por número de factura (orden natural). */
export const sortByInvoiceNumber = <T extends { invoiceNumber?: string | null }>(
  items: T[],
): T[] =>
  [...items]
    .filter(Boolean)
    .sort((a, b) => compareInvoiceNumber(a?.invoiceNumber, b?.invoiceNumber));

